<ng-container *ngIf="loading$ | async">
  <div class="order-section stencil-shimmer"></div>
</ng-container>

<div [hidden]="loading$ | async">
  <div *ngIf="uiPackages$ | async as uiPackages">
    <ng-container *ngIf="uiPackages.packages.length > 0">
      <ng-container *ngIf="!!compactView; else nonCompactPackageView">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'FRONTEND.SALES_UI.PACKAGES' | translate }}
            </mat-panel-title>
            <mat-panel-description>
              <span [ngPlural]="uiPackages.packages.length">
                <ng-template ngPluralCase="=1">1 {{ 'FRONTEND.SALES_UI.ITEM' | translate | lowercase }}</ng-template>
                <ng-template ngPluralCase="other">
                  {{ uiPackages.packages.length }}
                  {{ 'FRONTEND.SALES_UI.ITEMS' | translate | lowercase }}
                </ng-template>
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <sales-ui-sales-order-package-dropdown
            [compactView]="compactView"
            [title]="'FRONTEND.SALES_UI.PACKAGES'"
            [packages]="uiPackages.packages"
            [appsInPackages]="uiPackages.products"
            [statuses]="uiPackages.status || []"
            [showMenuItems]="showMenuItems"
            (menuItemClicked)="menuItemClick($event)"
          ></sales-ui-sales-order-package-dropdown>
        </mat-expansion-panel>
      </ng-container>
      <ng-template #nonCompactPackageView>
        <div class="order-section order-packages">
          <sales-ui-sales-order-package-dropdown
            [title]="'FRONTEND.SALES_UI.PACKAGES'"
            [packages]="uiPackages.packages"
            [appsInPackages]="uiPackages.products"
            [statuses]="uiPackages.status || []"
            [showMenuItems]="showMenuItems"
            (menuItemClicked)="menuItemClick($event)"
          ></sales-ui-sales-order-package-dropdown>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <div *ngIf="uiProducts$ | async as uiProducts">
    <ng-container *ngIf="uiProducts.products.length > 0">
      <ng-container *ngIf="!!compactView; else nonCompactPackageView">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'FRONTEND.SALES_UI.PRODUCTS' | translate }}
            </mat-panel-title>
            <mat-panel-description>
              <span [ngPlural]="uiProducts.products.length">
                <ng-template ngPluralCase="=1">1 {{ 'FRONTEND.SALES_UI.ITEM' | translate | lowercase }}</ng-template>
                <ng-template ngPluralCase="other">
                  {{ uiProducts.products.length }}
                  {{ 'FRONTEND.SALES_UI.ITEMS' | translate | lowercase }}
                </ng-template>
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <sales-ui-sales-order-package-dropdown
            [compactView]="compactView"
            [title]="'FRONTEND.SALES_UI.PRODUCTS'"
            [standAloneApps]="uiProducts.products"
            [statuses]="uiProducts.status || []"
            [showMenuItems]="showMenuItems"
            (menuItemClicked)="menuItemClick($event)"
          ></sales-ui-sales-order-package-dropdown>
        </mat-expansion-panel>
      </ng-container>
      <ng-template #nonCompactPackageView>
        <div class="order-section order-packages">
          <sales-ui-sales-order-package-dropdown
            [title]="'FRONTEND.SALES_UI.PRODUCTS'"
            [standAloneApps]="uiProducts.products"
            [statuses]="uiProducts.status || []"
            [showMenuItems]="showMenuItems"
            (menuItemClicked)="menuItemClick($event)"
          ></sales-ui-sales-order-package-dropdown>
        </div>
      </ng-template>
    </ng-container>
  </div>

  <div *ngIf="uiAddons$ | async as uiAddons">
    <ng-container *ngIf="uiAddons.addons.length > 0">
      <ng-container *ngIf="!!compactView; else nonCompactPackageView">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ 'FRONTEND.SALES_UI.ADDONS' | translate }}
            </mat-panel-title>
            <mat-panel-description>
              <span [ngPlural]="uiAddons.addons.length">
                <ng-template ngPluralCase="=1">1 {{ 'FRONTEND.SALES_UI.ITEM' | translate | lowercase }}</ng-template>
                <ng-template ngPluralCase="other">
                  {{ uiAddons.addons.length }}
                  {{ 'FRONTEND.SALES_UI.ITEMS' | translate | lowercase }}
                </ng-template>
              </span>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <sales-ui-sales-order-package-dropdown
            [compactView]="compactView"
            [title]="'FRONTEND.SALES_UI.ADDONS'"
            [standAloneApps]="uiAddons.addons"
            [statuses]="uiAddons.status || []"
            [showMenuItems]="showMenuItems"
            (menuItemClicked)="menuItemClick($event)"
          ></sales-ui-sales-order-package-dropdown>
        </mat-expansion-panel>
      </ng-container>
      <ng-template #nonCompactPackageView>
        <div class="order-section order-packages">
          <sales-ui-sales-order-package-dropdown
            [title]="'FRONTEND.SALES_UI.ADDONS'"
            [standAloneApps]="uiAddons.addons"
            [statuses]="uiAddons.status || []"
            [showMenuItems]="showMenuItems"
            (menuItemClicked)="menuItemClick($event)"
          ></sales-ui-sales-order-package-dropdown>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
